import React, { useState, useEffect } from 'react';
import {
  Link
} from "react-router-dom";
import Paginator from '../../components/Paginator';
import moment from 'moment';
import showdown from 'showdown';
import { returnImageMarkup } from '../../Utils';
const converter = new showdown.Converter();

export default function Magazine({ api }) {
  const [posts, setPosts] = useState([]);
  const [books, setBooks] = useState([]);

  const getPosts = async () => {
    let perPage = 20;
    let data = await window.ASTERISM.makeRequest(`list-all-else?page=${0}&per=${perPage}`);
    let newPosts = posts.concat(data);
    setPosts(newPosts);
  }

  const getBooks = async () => {
    let data = await window.ASTERISM.makeRequest('list-all-books?category=Firmament&per=1&page=0', 'GET');
    setBooks(data.books);
  }

  useEffect(() => {
    getPosts();
    getBooks();
    document.body.classList.add('magazine');
  }, []);

  const getSmallestImage = (image) => {
    if (!image) {
      return '';
    } else if (typeof image == 'string') {
      return image.replace('asterism-files.s3.amazonaws.com', 'files.sublunaryeditions.com');
    } else {
      let keys = Object.keys(image);
      return image[keys[0]].replace('asterism-files.s3.amazonaws.com', 'files.sublunaryeditions.com');
    }
  }

  const getFeaturedImage = (image) => {
    if (!image) {
      return '';
    } else if (typeof image == 'string') {
      return image.replace('asterism-files.s3.amazonaws.com', 'files.sublunaryeditions.com');
    } else {
      let keys = Object.keys(image);
      return image[keys[1]].replace('asterism-files.s3.amazonaws.com', 'files.sublunaryeditions.com');
    }
  }

  document.title = 'Firmament Magazine Online | Sublunary Editions';
  document.querySelector('meta[name="description"]').setAttribute("content", 'The official magazine of Sublunary Editions. Essays, poetry, fiction, and more every week.');

  return (
    <div>
      <div className='featured-area-plain magazine-home'>
        <div className='magazine-header'>
          <div className='magazine-name'>Firmament</div>
          <div className='magazine-tagline'><span>A magazine of considered miscellany from Sublunary Editions.</span> <Link to={`/magazine/page/2`} class='read-more-link'>Browse the Archive</Link></div>
        </div>
        <div className='post-grid'>
          {posts.slice(0, 1).map((post, index) =>
            <div key={post._id} className={`post-grid-item ${index === 0 || index === 6 || index === 10 ? 'first' : ''} ${post.featuredImage ? 'featured' : ''} vfirst`}>
              {post.featuredImage && <div className='post-featured'><div className='featured-screen'></div><div className='post-featured-image' style={{ backgroundImage: `url(${getFeaturedImage(post.featuredImage)})` }}></div></div>}
              <div className='post-grid-frame'></div>
              <div className='post-grid-item-content'>
                <div className='subtitle'>{moment(post.published).format('LL')} | {post.issueData && post.issueData._id ? <Link to={`/products/${post.issueData.slug}`}>{post.issueData.title.replace('Firmament ', '')}</Link> : 'Online'}</div>                <span class='title'><Link className='hov' to={`/magazine/${post.slug}`}>{post.title}</Link></span>
                <div className='subtitle'>by {post.byline}</div>
                <div className='excerpt' dangerouslySetInnerHTML={{ __html: post.excerpt }}></div>
              </div>
            </div>
          )}
          {books && books.length > 0 && <div className={`post-grid-item magazine`}>
            <div className='post-grid-frame'></div>
            <div className='post-grid-item-content magazine'>
              <div className='cover'>{returnImageMarkup(books[0].cover, `The latest issue of Firmament`)}</div>
              <div className='magazine-info'>
                <div className='subtitle'>Latest Issue | <Link to={`/firmament`} class='read-more-link'>Back Issues</Link></div>
                <span class='title'><Link className='hov' to={`/products/${books[0].slug}`}>{books[0].title}</Link></span>
                <div className='excerpt'>{books[0].subtitle}</div>
                <Link to={`/subscribe`} class='read-more-link'><button className='secondary-submit small'>Subscribe from $5/mo</button></Link>
              </div>
            </div>
          </div>}
          {posts.slice(1, 20).map((post, index) =>
            <div key={post._id} className={`post-grid-item ${(index === 6 || index === 11) && post.featuredImage ? 'first featured' : (index === 6 || index === 11) ? 'first' : ''}`}>
              <div className='post-grid-frame'></div>
              {post.featuredImage && (index === 6 || index === 11) && <div className='post-featured'><div className='featured-screen'></div><div className='post-featured-image' style={{ backgroundImage: `url(${getFeaturedImage(post.featuredImage)})` }}></div></div>}
              <div className='post-grid-item-content'>
                <div className='post-grid-header'>
                  {post.featuredImage && (index !== 6 && index !== 11) && <div className='post-mug-container'><div className='post-mug-image' style={{ backgroundImage: `url(${getSmallestImage(post.featuredImage)})` }}></div><div className='post-mug'></div></div>}
                  <div>
                    <div className='subtitle'>{moment(post.published).format('LL')} | {post.issueData && post.issueData._id ? <Link to={`/products/${post.issueData.slug}`}>{post.issueData.title.replace('Firmament ', '')}</Link> : 'Online'}</div>
                    <span class='title'><Link className='hov' to={`/magazine/${post.slug}`}>{post.title}</Link></span>
                    <div className='subtitle'>by {post.byline}</div>
                  </div>
                </div>
                {index !== 4 && index !== 8 && index !== 15 && <div className='excerpt' dangerouslySetInnerHTML={{ __html: post.excerpt }}></div>}
                {(index == 4 || index == 8 || index == 15) && <Link className='hov' to={`/magazine/${post.slug}`}><div className='excerpt' dangerouslySetInnerHTML={{ __html: `“${post.excerpt}”` }}></div></Link>}
                {(index == 4 || index == 8 || index == 15) && <div className='subtitle'>{post.byline}</div>}
              </div>
            </div>
          )}
        </div>
        <div className='text-center'><Link to={`/magazine/page/2`} class='read-more-link'><button className='secondary-submit'>See More</button></Link></div>
      </div>
    </div>
  )
}
